// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ticket {
  transition: all 0.4s ease-in-out;
}
.ticket:hover {
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);
}

.ticket-row {
  border-color:#edeff1;
  border-style: dashed;
  border:1px dashed #edeff1;
  transition: all 0.2s ease-in-out;
  vertical-align: center;

}

.ticket-row:hover{
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.ticket-table {
  width:90%;
  margin:auto;
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.app_global_search{
  width: 320px;
  .search_input{
    font-size: 0.70rem;
  }
  .search_btn{
    width: 125px;
    font-size: 12px;
  }
}

.rounded-checkbox {
  border-radius: 50%!important;
  height:1rem!important;
  width:1rem!important;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
}

.rounded-checkbox:checked {
  background-color: #ff4613;
}


.modal-big {
  width:1200px;
}



.custom-window-class > .modal-dialog,
.custom-window-class > .modal-dialog > .modal-content {
  width: 1200px!important;
  max-width: 1200px!important;
  min-width: 1200px!important;
}










.tab {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.tab:after {
  content: '';
  display: block;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  position: absolute;
  background-color: #ff4612;
  transition: transform ease 200ms, opacity ease 0ms 200ms;
  transform: translateX(100%);
  opacity: 0;
}
.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {
  transform: translateX(-100%);
}
.tabs-wrapper:not(:hover) .tab:not(.active)::after {
  transform: translateY(100%);
}
.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {
  transition-delay: 0ms, 0ms;
}
.tab.active::after, .tab:hover::after {
  transform: translateX(0%);
  opacity: 1;
}

p.tab {
  display: inline-block;
  text-decoration: none;
  color: #000;
  padding: 1rem;
}



.tox.tox-edit-area__iframe{
  background-color:blue!important
}

.tox-edit-area__iframe{
  background-color:blue!important
}
.tox{
  background-color:blue!important
}


.products {
  padding: 15px;
  max-width: 100%;

  .row {
    height: 80px;
    margin-bottom: 15px;
    display: flex;
    align-items: stretch;
    background-color: #fff;
    border-radius: 15px;

    .image {
      width: 120px;
      height: 80px;
      padding: 5px;
      display: flex;
      align-items: center;

      img {
        width: 100%;
      }
    }

    .type {
      display: flex;
      align-items: center;
      flex-grow: 2;
      justify-content: center;
      padding: 15px;
      border-left: #ddd solid 1px;
    }

    .account {
      display: flex;
      flex-grow: 3;
      flex-direction: column;
      justify-content: center;
      padding: 15px;
      border-left: #ddd solid 1px;
    }
  }
}

.tableClassName tbody {
  display: block;
  max-height: 400px;
  overflow-y: scroll;
}

.tableClassName thead,
tfoot,
tbody tr {
//display: table;
  width: 100%;
  table-layout: fixed;
}

table {
  background-color: white;
  border-radius: 10px;
  margin: 20px;
  width: 95%;
}

.heading {
  margin-left: 20px;
  margin-top: 10px;
  font-size: 15px;
}

.green_button {
  background-color: #46a00d;
  color: #fff;
  font-size: 13px;
  border-radius: 30px;
  display: table;
  padding: 3px 15px;
  width: inherit;
}

.container {
  margin: 1em auto;
  font-family: sans-serif;
  width: 90%;
}

.expandable-table {
  border-collapse: collapse;
  background-color: white;
}

.expandable-table__header-row {
}

.expandable-table__header-heading {
  padding: 1em;
  text-align: left;
}

.expandable-table__header-heading--sortable:after {
  float: right;
}

.expandable-table__row {
  transition: background-color .1s ease-out;
  border-bottom: 1px solid #eee;
}

.expandable-table__row:hover {
  background-color: #eee;

}

.expandable-table__cell {
  padding: 1em;
}

.question:hover {
  cursor: pointer;
}


.expandable-table__details-row {
  display: none;
}

.expandable-table__details-row--visible {
  display: table-row;
}

.expandable-table__details {
  padding: 0 1em;
}


.tableClassName3 tbody {
  display: block;
  max-height: 400px;
  overflow-y: scroll;
}

.tableClassName3 thead,
.tableClassName3 tfoot,
.tableClassName3 tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.already-has-ticket {
  background-color: #fbeaea;
  border-color: #f4d1d1;
  color: #c02b2e;
}

.product-page-button-container {
  display: flex;
  justify-content: space-around
}

.product-page-button {
  color: #fff;
  padding: 10px 20px;
  border-radius: 28px;
  font-size: 14px;
}

.btn-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.add-to-table-button {
  padding-bottom: 15px;
}

.row {
  height: 80px;
  margin-bottom: 15px;
  display: flex;
  align-items: stretch;
  background-color: #fff;
  border-radius: 15px;
}

.account {
  display: flex;
  flex-grow: 3;
  flex-direction: column;
  justify-content: center;
  padding: 15px;
  border-left: #ddd solid 1px;
}

.m-b-60{
  margin-bottom: 60px;
}

.title{
  display: inline;
  font-size: 12px;
  font-weight: 600;
  color: #FF4612;
  margin-left: 10px;
}


.add-to-table-button {
  padding-bottom: 15px;
}

.row {
  height: 80px;
  margin-bottom: 15px;
  display: flex;
  align-items: stretch;
  background-color: #fff;
  border-radius: 15px;
}

.account {
  display: flex;
  flex-grow: 3;
  flex-direction: column;
  justify-content: center;
  padding: 15px;
  border-left: #ddd solid 1px;
}

.m-b-60{
  margin-bottom: 60px;
}

.title{
  display: inline;
  font-size: 12px;
  font-weight: 600;
  color: #FF4612;
  margin-left: 10px;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/ticketing/components/system-fields-directives/warranty-ticket-directive/warranty-ticket-directive.css"],"names":[],"mappings":";AACA;EACE,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;;AAExB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,YAAY;AACd;;;;AAIA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;;;;;;;;;;AAWA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;EACxD,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;;;;AAIA;EACE;AACF;;AAEA;EACE;AACF;AACA;EACE;AACF;;;AAGA;EACE,aAAa;EACb,eAAe;;EAEf;IACE,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;;IAEnB;MACE,YAAY;MACZ,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,mBAAmB;;MAEnB;QACE,WAAW;MACb;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,uBAAuB;MACvB,aAAa;MACb,2BAA2B;IAC7B;;IAEA;MACE,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,aAAa;MACb,2BAA2B;IAC7B;EACF;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;AAGA,gBAAgB;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;;AAExB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAElB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AACA,4mXAA4mX","sourcesContent":["\n.ticket {\n  transition: all 0.4s ease-in-out;\n}\n.ticket:hover {\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);\n}\n\n.ticket-row {\n  border-color:#edeff1;\n  border-style: dashed;\n  border:1px dashed #edeff1;\n  transition: all 0.2s ease-in-out;\n  vertical-align: center;\n\n}\n\n.ticket-row:hover{\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.ticket-table {\n  width:90%;\n  margin:auto;\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.app_global_search{\n  width: 320px;\n  .search_input{\n    font-size: 0.70rem;\n  }\n  .search_btn{\n    width: 125px;\n    font-size: 12px;\n  }\n}\n\n.rounded-checkbox {\n  border-radius: 50%!important;\n  height:1rem!important;\n  width:1rem!important;\n  border: 1px solid #ddd;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n}\n\n.rounded-checkbox:checked {\n  background-color: #ff4613;\n}\n\n\n.modal-big {\n  width:1200px;\n}\n\n\n\n.custom-window-class > .modal-dialog,\n.custom-window-class > .modal-dialog > .modal-content {\n  width: 1200px!important;\n  max-width: 1200px!important;\n  min-width: 1200px!important;\n}\n\n\n\n\n\n\n\n\n\n\n.tab {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n.tab:after {\n  content: '';\n  display: block;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  position: absolute;\n  background-color: #ff4612;\n  transition: transform ease 200ms, opacity ease 0ms 200ms;\n  transform: translateX(100%);\n  opacity: 0;\n}\n.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {\n  transform: translateX(-100%);\n}\n.tabs-wrapper:not(:hover) .tab:not(.active)::after {\n  transform: translateY(100%);\n}\n.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {\n  transition-delay: 0ms, 0ms;\n}\n.tab.active::after, .tab:hover::after {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\np.tab {\n  display: inline-block;\n  text-decoration: none;\n  color: #000;\n  padding: 1rem;\n}\n\n\n\n.tox.tox-edit-area__iframe{\n  background-color:blue!important\n}\n\n.tox-edit-area__iframe{\n  background-color:blue!important\n}\n.tox{\n  background-color:blue!important\n}\n\n\n.products {\n  padding: 15px;\n  max-width: 100%;\n\n  .row {\n    height: 80px;\n    margin-bottom: 15px;\n    display: flex;\n    align-items: stretch;\n    background-color: #fff;\n    border-radius: 15px;\n\n    .image {\n      width: 120px;\n      height: 80px;\n      padding: 5px;\n      display: flex;\n      align-items: center;\n\n      img {\n        width: 100%;\n      }\n    }\n\n    .type {\n      display: flex;\n      align-items: center;\n      flex-grow: 2;\n      justify-content: center;\n      padding: 15px;\n      border-left: #ddd solid 1px;\n    }\n\n    .account {\n      display: flex;\n      flex-grow: 3;\n      flex-direction: column;\n      justify-content: center;\n      padding: 15px;\n      border-left: #ddd solid 1px;\n    }\n  }\n}\n\n.tableClassName tbody {\n  display: block;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n\n.tableClassName thead,\ntfoot,\ntbody tr {\n//display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\ntable {\n  background-color: white;\n  border-radius: 10px;\n  margin: 20px;\n  width: 95%;\n}\n\n.heading {\n  margin-left: 20px;\n  margin-top: 10px;\n  font-size: 15px;\n}\n\n.green_button {\n  background-color: #46a00d;\n  color: #fff;\n  font-size: 13px;\n  border-radius: 30px;\n  display: table;\n  padding: 3px 15px;\n  width: inherit;\n}\n\n.container {\n  margin: 1em auto;\n  font-family: sans-serif;\n  width: 90%;\n}\n\n.expandable-table {\n  border-collapse: collapse;\n  background-color: white;\n}\n\n.expandable-table__header-row {\n}\n\n.expandable-table__header-heading {\n  padding: 1em;\n  text-align: left;\n}\n\n.expandable-table__header-heading--sortable:after {\n  float: right;\n}\n\n.expandable-table__row {\n  transition: background-color .1s ease-out;\n  border-bottom: 1px solid #eee;\n}\n\n.expandable-table__row:hover {\n  background-color: #eee;\n\n}\n\n.expandable-table__cell {\n  padding: 1em;\n}\n\n.question:hover {\n  cursor: pointer;\n}\n\n\n.expandable-table__details-row {\n  display: none;\n}\n\n.expandable-table__details-row--visible {\n  display: table-row;\n}\n\n.expandable-table__details {\n  padding: 0 1em;\n}\n\n\n.tableClassName3 tbody {\n  display: block;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n\n.tableClassName3 thead,\n.tableClassName3 tfoot,\n.tableClassName3 tbody tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.already-has-ticket {\n  background-color: #fbeaea;\n  border-color: #f4d1d1;\n  color: #c02b2e;\n}\n\n.product-page-button-container {\n  display: flex;\n  justify-content: space-around\n}\n\n.product-page-button {\n  color: #fff;\n  padding: 10px 20px;\n  border-radius: 28px;\n  font-size: 14px;\n}\n\n.btn-group {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.add-to-table-button {\n  padding-bottom: 15px;\n}\n\n.row {\n  height: 80px;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: stretch;\n  background-color: #fff;\n  border-radius: 15px;\n}\n\n.account {\n  display: flex;\n  flex-grow: 3;\n  flex-direction: column;\n  justify-content: center;\n  padding: 15px;\n  border-left: #ddd solid 1px;\n}\n\n.m-b-60{\n  margin-bottom: 60px;\n}\n\n.title{\n  display: inline;\n  font-size: 12px;\n  font-weight: 600;\n  color: #FF4612;\n  margin-left: 10px;\n}\n\n\n.add-to-table-button {\n  padding-bottom: 15px;\n}\n\n.row {\n  height: 80px;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: stretch;\n  background-color: #fff;\n  border-radius: 15px;\n}\n\n.account {\n  display: flex;\n  flex-grow: 3;\n  flex-direction: column;\n  justify-content: center;\n  padding: 15px;\n  border-left: #ddd solid 1px;\n}\n\n.m-b-60{\n  margin-bottom: 60px;\n}\n\n.title{\n  display: inline;\n  font-size: 12px;\n  font-weight: 600;\n  color: #FF4612;\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
